import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import DeleteAccount from '@/views/DeleteAccount.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/DeleteAccount',
    name: 'DeleteAccount',
    component: DeleteAccount
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
